/**
 * Amounts that qualify for shop free-shipping threshold (excluding donation lines when configured).
 */

export function lineCountsTowardFreeShipping(item) {
  if (!item) return false;
  const isDonation = item.type === 'donation' || item.productType === 'donation';
  if (isDonation && item.countTowardFreeShipping === false) return false;
  return true;
}

/** Sum(price * qty) for lines that count toward the free-shipping floor */
export function getSubtotalForFreeShippingEligible(cartItems) {
  if (!Array.isArray(cartItems)) return 0;
  return cartItems.reduce((sum, item) => {
    if (!lineCountsTowardFreeShipping(item)) return sum;
    const qty = item.quantity ?? 1;
    const unit = typeof item.price === 'number' ? item.price : parseFloat(item.price || 0);
    if (!Number.isFinite(unit)) return sum;
    return sum + unit * qty;
  }, 0);
}
